import { translateLabel } from "@/i18n/messages";
export const trailStatusMeta = (status) => {
  switch ((status || "unknown").toLowerCase()) {
    case "open": return { label: translateLabel("Open"), tone: "open" };
    case "closed": return { label: translateLabel("Currently closed"), tone: "closed" };
    case "restricted": return { label: translateLabel("Restricted"), tone: "restricted" };
    default: return { label: translateLabel("Status unknown"), tone: "unknown" };
  }
};

export const knownValue = (value, formatter = (known) => String(known)) =>
  value == null || value === "" ? translateLabel("Unknown") : formatter(value);

export const geometrySourceMeta = (source, verified, provider) => {
  if (!source) return { label: translateLabel("Geometry unavailable"), verified: false };
  const normalized = source.toLowerCase();
  const labels = {
    gpx: "GPX track",
    official: "Official geometry",
    community: "Community geometry",
    import: "Imported geometry",
    preview: "Preview geometry",
  };
  const normalizedProvider = provider?.trim().toUpperCase();
  return {
    label: normalizedProvider === "TRAILFORKS" ? translateLabel("Trailforks geometry") : translateLabel(labels[normalized] || `${normalized} geometry`),
    verified: verified === true,
  };
};

export const trailAttributeLabel = (attribute) => ({
  flow: "Flow",
  technical: "Technical",
  jumps: "Jumps",
  drops: "Drops",
  steep: "Steep",
  roots: "Roots",
  rocky: "Rocky",
  exposure: "Exposure",
}[attribute?.toLowerCase()] ? translateLabel(({ flow: "Flow", technical: "Technical", jumps: "Jumps", drops: "Drops", steep: "Steep", roots: "Roots", rocky: "Rocky", exposure: "Exposure" })[attribute?.toLowerCase()]) : attribute);
